import { render } from "./BlogLatest.vue?vue&type=template&id=bd26980a"
import script from "./BlogLatest.vue?vue&type=script&lang=js"
export * from "./BlogLatest.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__